import React, { useEffect, useState } from "react";
import RankService from "../../services/rank.service";
import { Button, Spinner } from "react-bootstrap";
import CommonService from "../../services/common.service";
import StatService from "../../services/stat.service";
import StatsCardModalDownload from "../Stat/StatsCardModalDownload";

const StatsDownload = (props) => {
  const [roundListing, setRoundListing] = useState([]);
  const [topTenRecord, setTopTenRecord] = useState([]);
  const [statsRecordType, setStatsRecordType] = useState("");
  const [gameInfoBlockData, setGameInfoBlockData] = useState({});
  useEffect(() => {
    if (props.showStatsTab) {
      StatService.getStat()
        .then((res) => {
          if (res.success) {
            setTopTenRecord(res.data.topTenRecord);
          }
          return CommonService.getRoundListing(); // Chain the second API call
        })
        .then((res) => {
          if (res.success) {
            setRoundListing(res.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [props.showStatsTab]);

  const [loadingStates, setLoadingStates] = useState({}); // Maintain separate loading states for each button
  const [roundId, setRoundId] = useState("");
  const roundDropdown = (e) => {
    setRoundId(e.target.value);
  };
  const handleDownloadStatsByType = (type) => {
    setLoadingStates((prev) => ({ ...prev, [type]: true })); // Set loading for the specific type
    setStatsRecordType(type);
    StatService.getStat(roundId)
      .then((res) => {
        if (res.success) {
          const sortedData = [...res.data.topTenRecord].sort(dynamicSort(type));
          setTopTenRecord(sortedData);
          setGameInfoBlockData(res.gameInfoBlockData);
          setShowRankModal(true);
        }
      })
      .finally(() => {
        setLoadingStates((prev) => ({ ...prev, [type]: false })); // Stop loading for the specific type
      });
  };

  const [showRankModal, setShowRankModal] = useState(false);
  const [rankModalDetails, setRankModalDetails] = useState([]);

  const handleRankModalClose = () => setShowRankModal(false);

  const handleRankModalShow = () => {
    RankService.topTenRank().then((res) => {
      if (res.success) {
        setRankModalDetails(res.data);
        setGameInfoBlockData(res.gameInfoBlockData);
        setShowRankModal(true);
      }
    });
  };

  const dynamicSort = (property = "sum_fp") => {
    return function (a, b) {
      const valueA = a[property];
      const valueB = b[property];

      // Handle undefined values
      if (valueA === undefined || valueB === undefined) {
        return valueA === undefined ? 1 : -1;
      }

      // Sorting for numbers (descending order)
      if (typeof valueA === "number" && typeof valueB === "number") {
        return valueB - valueA; // Descending order
      }

      // Sorting for strings (descending order)
      if (typeof valueA === "string" && typeof valueB === "string") {
        return valueB.localeCompare(valueA); // Descending order
      }

      // Fallback for mixed types
      return valueB.toString().localeCompare(valueA.toString());
    };
  };

  const statTypes = [
    { label: "Fantasy Points", key: "sum_fp" },
    { label: "Runs", key: "sum_rs" },
    { label: "Fours", key: "sum_fours" },
    { label: "Sixes", key: "sum_sixes" },
    { label: "Wickets", key: "sum_wks" },
    { label: "Maidens", key: "sum_mdns" },
    { label: "Hat-Trick", key: "sum_hattrick" },
    { label: "Catches", key: "sum_cs" },
    { label: "Catches WK", key: "sum_cwk" },
    { label: "Stumpings", key: "sum_sts" },
    { label: "Overs", key: "sum_overs" },
    { label: "Average-Points", key: "avg_pts" },
    { label: "Pick-CAP%", key: "pcap" },
    { label: "Pick-VCAP%", key: "pvcap" },
  ];

  return (
    <>
      <div className="searchfilter">
        <select
          className="selectdropdown"
          onChange={roundDropdown}
          value={roundId}
        >
          <option value={0}>Overall</option>
          {roundListing &&
            roundListing.map((item) => (
              <option key={item.round} value={item.round}>
                Round {item.round}
              </option>
            ))}
        </select>
      </div>
      <div className="customscroll rankcustomscroll">
        <table className="table ranktable rankNewTableClass">
          <thead>
            <tr>
              <th>Type</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {statTypes.map(({ label, key }) => (
              <tr key={key}>
                <td>{label}</td>
                <td style={{ textAlign: "center" }}>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleDownloadStatsByType(key)}
                    disabled={loadingStates[key]}
                  >
                    {loadingStates[key] ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        Loading...
                      </>
                    ) : (
                      "Download"
                    )}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <div className="customscroll rankcustomscroll pt-2">
        <table className="table ranktable rankNewTableClass">
          <thead>
            <tr>
              <th>Type</th>
              <th>Round</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {statTypes.map(({ label, key }) => (
              <tr key={key}>
                <td>{label}</td>
                <td>
                  <select
                    className="form-control"
                    onChange={roundDropdown}
                    value={roundId}
                  >
                    <option>Select Round</option>
                    {roundListing &&
                      roundListing.map((item) => (
                        <option key={item.round} value={item.round}>
                          Round {item.round}
                        </option>
                      ))}
                  </select>
                </td>
                <td style={{ textAlign: "center" }}>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => handleDownloadStatsByType(data, key)}
                    disabled={loadingStates[key]} // Check loading state for the key
                  >
                    {loadingStates[key] ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        Loading...
                      </>
                    ) : (
                      "Download"
                    )}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
      <StatsCardModalDownload
        showRankModal={showRankModal}
        handleRankModalClose={handleRankModalClose}
        handleRankModalShow={handleRankModalShow}
        rankModalDetails={rankModalDetails}
        topTenRecord={topTenRecord}
        gameInfoBlockData={gameInfoBlockData}
        statsRecordType={statsRecordType}
        roundId={roundId}
      />
    </>
  );
};

export default StatsDownload;
